<template>
  <div>
    <crawler-config-selector
      v-if="config.all.length > 0"
      :configs="config.all"
      :name.sync="config.active.name"
      :version.sync="config.active.version"
      @changed="activeConfigChanged"
    ></crawler-config-selector>

    <v-row>
      <v-col class="col-12 col-lg-4">
        <crawler-config-form
          ref="config-form"
          :browser.sync="config.fields.browser"
          :parser.sync="config.fields.parser">
        </crawler-config-form>

        <div>
          <v-row class="mt-1 mb-1">
            <v-col>
              <v-tooltip bottom v-if="isProduction" max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined block color="warning" :disabled="!isDirty" @click="save" v-bind="attrs" v-on="on">
                    <v-icon left dark>mdi-alert</v-icon>
                    Sauvegarder
                  </v-btn>
                </template>
                <span>Attention, cette configuration est en production. Toute modification sera instantanément pris en
                  compte par le système</span>
              </v-tooltip>
              <v-btn v-else outlined block color="primary" :disabled="!isDirty" @click="save">
                <v-icon left dark>mdi-pencil</v-icon>
                Sauvegarder
              </v-btn>
            </v-col>
            <v-col>
              <v-btn outlined block color="primary" @click="saveNew">
                <v-icon left dark>mdi-content-copy</v-icon>
                Sauv. une copie
              </v-btn>
            </v-col>
            <v-col>
              <v-btn outlined block color="warning" :disabled="isProduction" @click="publish">
                <v-icon left dark>mdi-cloud-upload</v-icon>
                Mettre en production
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col class="col-12 col-lg-8">
        <crawler-inspection-form :config="config.fields" @created="hash => inspection.hash = hash">
        </crawler-inspection-form>
        <crawler-inspection-table :hash="inspection.hash"></crawler-inspection-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CrawlerInspectionTable from './AdminCrawlerConfig/CrawlerInspectionTable'
import CrawlerInspectionForm from './AdminCrawlerConfig/CrawlerInspectionForm'
import CrawlerConfigForm from './AdminCrawlerConfig/CrawlerConfigForm'
import CrawlerConfigSelector from '@/views/Pages/Admin/AdminCrawlerConfig/CrawlerConfigSelector'

export default {
  name: 'AdminCrawlerConfigPage',
  components: { CrawlerConfigSelector, CrawlerConfigForm, CrawlerInspectionForm, CrawlerInspectionTable },
  data () {
    return {
      inspection: {
        hash: null
      },
      config: {
        all: [],
        active: {
          name: null,
          version: null
        },
        fields: {
          browser: null,
          parser: null,
          dirty: false
        }
      }
    }
  },
  computed: {
    activeConfig () {
      return this.config.all.find(config => {
        return config.name === this.config.active.name && config.version === this.config.active.version
      })
    },
    isDirty () {
      if (!this.activeConfig) return false
      if (JSON.stringify(this.config.fields.browser).trim() !== JSON.stringify(this.activeConfig.browser).trim()) return true
      if (JSON.stringify(this.config.fields.parser).trim() !== JSON.stringify(this.activeConfig.parser).trim()) return true
      return false
    },
    isProduction () {
      if (!this.activeConfig) return false
      if (this.activeConfig.production) return true
      return false
    },
  },
  methods: {
    activeConfigChanged () {
      this.config.fields.browser = Object.assign({}, this.activeConfig.browser)
      this.config.fields.parser = Object.assign({}, this.activeConfig.parser)
    },
    async save () {
      await this.$api.put('crawler/configs/' + this.activeConfig.id, {
        name: this.activeConfig.name,
        version: this.activeConfig.version,
        browser: this.config.fields.browser,
        parser: this.config.fields.parser
      })
      await this.fetch()
    },
    async saveNew () {
      const newVersion = this.activeConfig.version + 1

      await this.$api.post('crawler/configs', {
        name: this.activeConfig.name,
        version: newVersion,
        browser: this.config.fields.browser,
        parser: this.config.fields.parser,
      })
      await this.fetch()
      this.config.active.version = newVersion
    },
    async publish () {
      await this.$api.put('crawler/configs/' + this.activeConfig.id, {
        production: true,
      })
      await this.fetch()
    },
    async fetch () {
      this.config.all = (await this.$api.get('crawler/configs')).data
    }
  },
  async mounted () {
    this.fetch()
  }
}
</script>